import { CREATE_LDP, DELETE_LDP, GET_LDP, GET_LDP_BY_ID, UPDATE_LDP } from '@/api/master-data/ldp/ldp';

const state = {
  ldps: [],
  ldp: {},
  totalItems: 0,
  totalPages: 0,
  currentPage: 1,
  limit: 10,
  loading: false,
};

const mutations = {
  setLdps: (state, payload) => {
    state.ldps = payload.data || [];
    state.totalItems = payload.totalItems || 0;
    state.totalPages = payload.totalPages || 0;
    state.currentPage = payload.page || 1;
    state.limit = payload.limit || 10;
  },
  setLdp: (state, payload) => {
    state.ldp = payload;
  },
  setLoading: (state, loading) => {
    state.loading = loading;
  },
};

const actions = {
  getLdps: async ({ commit }, params) => {
    commit('setLoading', true);
    try {
      const resp = await GET_LDP(params);
      if (resp.data.httpCode === 200) {
        commit('setLdps', resp.data.data);
        return resp.data.data;
      }
    } catch (err) {
      const resp = err.response;
      if (resp && resp.data && resp.data.httpCode === 404) {
        commit('setLdps', { data: [], totalItems: 0 });
      }
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },

  getLdpById: async ({ commit }, id) => {
    commit('setLoading', true);
    try {
      const resp = await GET_LDP_BY_ID(id);
      if (resp.data.httpCode === 200) {
        commit('setLdp', resp.data.data);
        return resp.data;
      }
    } finally {
      commit('setLoading', false);
    }
  },

  createLdp: async ({ commit }, data) => {
    commit('setLoading', true);
    try {
      const resp = await CREATE_LDP(data);
      return resp.data;
    } finally {
      commit('setLoading', false);
    }
  },

  updateLdp: async ({ commit }, { id, data }) => {
    commit('setLoading', true);
    try {
      const resp = await UPDATE_LDP(id, data);
      return resp.data;
    } finally {
      commit('setLoading', false);
    }
  },

  deleteLdp: async ({ commit }, id) => {
    commit('setLoading', true);
    try {
      const resp = await DELETE_LDP(id);
      return resp.data;
    } finally {
      commit('setLoading', false);
    }
  },
};

const getters = {
  getLdps: () => state.ldps,
  getLdp: () => state.ldp,
  getTotalItems: () => state.totalItems,
  getTotalPages: () => state.totalPages,
  getCurrentPage: () => state.currentPage,
  getLimit: () => state.limit,
  getLoading: () => state.loading,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
